(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("messageService", ["notify", messageService]);
    function messageService(notify) {
        var messageServiceFactory = {
            success: success,
            warning: warning,
            error: error,
            custom: custom,
            closeAll: closeAll,
            getErrorMessage: getErrorMessage
        };
        notify.config({ duration: 6000 });
        function success(message, values, extend) {
            var options = {};
            if (values) {
                options = { messageTemplate: "<span translate=\"" + message + "\" translate-values=" + JSON.stringify(values) + "></span>", classes: "alert-success" };
            }
            else {
                options = { messageTemplate: "<span translate=\"" + message + "\"></span>", classes: "alert-success" };
            }
            if (extend)
                angular.extend(options, extend);
            return notify(options);
        }
        function warning(message, extend) {
            var options = { messageTemplate: "<span translate=\"" + message + "\"></span>", classes: "alert-warning" };
            if (extend)
                angular.extend(options, extend);
            return notify(options);
        }
        function error(message, values) {
            var options = {};
            var errorText;
            if (typeof message === "string") {
                errorText = message;
            }
            else {
                if (message.data) {
                    if (message.data.exceptionMessage)
                        errorText = message.data.exceptionMessage;
                    else if (message.data.message)
                        errorText = message.data.message;
                    else if (message.status === 400)
                        errorText = "common.exception.400.invalidModelState";
                    else
                        errorText = message.data;
                }
                else {
                    errorText = "common.genericError";
                }
            }
            if (values) {
                options = { messageTemplate: "<span translate=\"" + errorText + "\" translate-values=" + JSON.stringify(values) + "></span>", classes: "alert-danger" };
            }
            else {
                options = { messageTemplate: "<span translate=\"" + errorText + "\"></span>", classes: "alert-danger" };
            }
            return notify(options);
        }
        function getErrorMessage(message) {
            if (typeof message === "string") {
                return message;
            }
            else {
                var errorText = void 0;
                if (message.data) {
                    if (message.data.exceptionMessage)
                        errorText = message.data.exceptionMessage;
                    else if (message.data.message)
                        errorText = message.data.message;
                    else
                        errorText = message.data;
                }
                else
                    errorText = "common.genericError";
                return errorText;
            }
        }
        function custom(options) {
            return notify(options);
        }
        function closeAll() {
            notify.closeAll();
        }
        return messageServiceFactory;
    }
}());
